import React from "react";
import { Button, Form, Modal } from "react-bootstrap";

import { COLOR_WHITE, LINEAR_GRADIENT_BG } from "../../../../const";

export default function EditAttributeValueModal({
  show,
  onClose,
  attributes,
  selectedAttributeId,
  setSelectedAttributeId,
  valuesText,
  setValuesText,
  disableAttributeSelect,
  disableClose,
  disableSave,
  onSave,
}) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>ແກ້ໄຂຄ່າ</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ background: COLOR_WHITE }}>
          <Form.Group className="mb-3">
            <Form.Label>ຄຸນລັກສະນະ</Form.Label>
            <Form.Select
              value={selectedAttributeId}
              onChange={(e) => setSelectedAttributeId(e.target.value)}
              disabled={disableAttributeSelect}
            >
              {attributes.map((a) => (
                <option key={a.id} value={a.id}>
                  {a.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group>
            <Form.Label>ຄ່າ</Form.Label>
            <Form.Control
              value={valuesText}
              onChange={(e) => setValuesText(e.target.value)}
              placeholder="S M L ສີ"
            />
          </Form.Group>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose} disabled={disableClose}>
          ຍົກເລີກ
        </Button>
        <Button
          style={{ background: LINEAR_GRADIENT_BG, border: "none" }}
          onClick={onSave}
          disabled={disableSave}
        >
          ບັນທຶກ
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
